export const RoundInstructionDisplay = (props: { roundNumber?: number; instruction?: string }) => {
    const { instruction, roundNumber } = props;

    const label = `Round ${roundNumber}`;

    if (!instruction) {
        return null;
    }

    return (
        <div className="vstack gap-1" key={roundNumber}>
            <div className="h6">{label}</div>
            <div>{instruction}</div>
        </div>
    );
};

export const RoundInstructionsDisplay = (props: {
    roundInstructions: Array<{
        roundNumber?: number;
        name?: string;
    }>;
}) => {
    const { roundInstructions } = props;

    return roundInstructions.length > 0 ? (
        <div className="vstack gap-4">
            {roundInstructions.map(r => (
                <RoundInstructionDisplay key={r.roundNumber} instruction={r.name} roundNumber={r.roundNumber} />
            ))}
        </div>
    ) : null;
};
